import React from "react";

export const Marquee = () => {
  const text = "APT 1968 — POLISPORTIVA TRICESIMO — DAL 1968 — #FORZAPOLISPORTIVA — ";
  const items = Array(2).fill(text).join("");
  return (
    <div data-testid="marquee" className="bg-navy py-5 overflow-hidden border-y-4 border-court">
      <div className="flex whitespace-nowrap animate-marquee">
        <span className="font-heading uppercase tracking-wide text-3xl md:text-4xl text-gold">
          {items}
        </span>
        <span className="font-heading uppercase tracking-wide text-3xl md:text-4xl text-gold" aria-hidden="true">
          {items}
        </span>
      </div>
    </div>
  );
};

export default Marquee;
